<section id="main" class="bg-light">
     <div id="invoiceContainer" class="container">
          <h1 [innerHTML]="'WSAPI_1' | translator:'webservice'">Request Web Service Access</h1>
          <div class="row">
               <div id="billigReportContainer" class="col-lg-8">
                    <h2 class="h6 text-body fw-bold m-0" [innerHTML]="'WSAPI_2' | translator:'webservice'">Overview</h2>
                    <p [innerHTML]="'WSAPI_3' | translator:'webservice'">The Pre-Employment Screening Program allows
                         system-to-system data requests for entities using a REST protocol leveraging
                         API tokens to obtain driver records.</p>
                    <p [innerHTML]="'WSAPI_4' | translator:'webservice'">The Department of Transportation (DOT)
                         restricts the recipients of this data to be specifically for the prospective
                         driver, for whom the data is being requested, or an account holder for which the prospective
                         driver has explicitly
                         provided written consent. Account holders include motor carriers (MC) and industry service
                         providers (ISP).</p>
                    <p [innerHTML]="'WSAPI_5' | translator:'webservice'">All recipients of the PSP data are subject to
                         legal agreements. The agreements ensure that account holders have properly
                         obtained the driver's consent prior to requesting the PSP record before driver employment has
                         occurred.</p>
                    <h2 class="h6 text-body fw-bold m-0" [innerHTML]="'WSAPI_6' | translator:'webservice'">Requesting
                         Web Service Access</h2>
                    <p>
                         <span [innerHTML]="'WSAPI_7' | translator:'webservice'">To obtain PSP web service access please
                              contact the customer service team at</span>
                         <a href="tel:877-642-9499" title="1-877-642-9499" name="1-877-642-9499"
                              class="text-underline">1-877-642-9499</a>
                         <span [innerHTML]="'WSAPI_8' | translator:'webservice'"> or by email at </span>
                         <a href="mailto:PSPHelp@tylertech.com" title="PSPHelp@tylertech.com"
                              name="PSPHelp@tylertech.com">PSPHelp&#64;tylertech.com</a>.
                    </p>
                    <h2 class="h6 text-body fw-bold m-0" 
                         [innerHTML]="'WSAPI_9' | translator:'webservice'">
                         Implementation Guide</h2>
                    <p [innerHTML]="'WSAPI_10' | translator:'webservice'">
                         The PSP web service implementation guide provides a high-level overview for implementing and interfacing with the standard XML log of driver collisions and inspections and provides guidance on formatting a JSON request to receive a JSON, XML or PDF response containing the PSP data.
                    </p>
                    <p>
                         <span [innerHTML]="'WSAPI_11' | translator:'webservice'">Click</span>
                         <a [href]="updateUrl('##docBaseUrl##/FMCSA PSP-REST-WS_ProtocolImplementationGuide.pdf')"
                              target="_blank" id="linkAHManual" name="linkAHManual" role="button"
                              [innerHTML]="'WSAPI_12' | translator:'webservice'"
                              [title]="'WSToken_Overview_2' | translator:'webservice'">
                              here
                         </a>
                         <span [innerHTML]="'WSAPI_13' | translator:'webservice'">
                              to download a copy of the implementation guide.
                         </span>
                    </p>
                    <p class="italic" [innerHTML]="'WSAPI_14' | translator:'webservice'">
                         Note: The PSP team will provide REST API implementation support as needed.
                    </p>
               </div>
               <div class="col-lg-4 order-lg-2 sidebar">
                    <app-dashboardsupport></app-dashboardsupport>
                    <div class="card shadow-sm rounded-0 border-0">
                         <div class="card-body">
                              <h2 class="card-title h5 mt-0" [innerHTML]="'Resources' | translator:'base'">Resources
                              </h2>
                              <ul>
                                   <li *ngIf="companyType === 'MC'">
                                        <button (click)="openDocument('PSPMotorCarrierEnrollment')" target="_blank"
                                             class="btn btn-link" [title]="'MAHEnrollAgreement' | translator:'base'"
                                             [innerHTML]="'MAHEnrollAgreement' | translator:'base'" name="MAHagreement"
                                             id="MAHagreement">PSP Monthly Account Holder Enrollment
                                             Agreement</button>
                                   </li>
                                   <li *ngIf="companyType === 'ISP'">
                                        <button (click)="openDocument('ISPAccountHolderAgreement')" target="_blank"
                                             class="btn btn-link" [title]="'ISPEnrollAgreement' | translator:'base'"
                                             [innerHTML]="'ISPEnrollAgreement' | translator:'base'" name="ISPagreement"
                                             id="ISPagreement">PSP Industry Service Provider Enrollment
                                             Agreement</button>
                                   </li>
                                   <li>
                                        <button class="btn btn-link"
                                             [innerHTML]="'DisclosureAndAuth' | translator:'base'"
                                             [title]="'DisclosureAndAuth' | translator:'base'"
                                             (click)="openDocument('PSPDisclosureandAuthorizationForm')" target="_blank"
                                             name="dna" id="dna">Disclosure and Authorization Form</button>
                                   </li>
                              </ul>
                         </div>
                    </div>
               </div>
          </div>
     </div>
</section>